import React from 'react';
import { Button } from 'reactstrap';
import { useHistory, useLocation} from 'react-router-dom';
import './PageControls.scss';

function BackButton(props){
  let history = useHistory();
  let buttonText = (typeof props.name !== 'undefined') ? props.name : 'Back';

  return(
    <Button outline color="secondary" className="float-start" onClick={() => {history.goBack();}}>{buttonText}</Button>
  );
}

//https://artwilton.medium.com/adding-a-link-to-a-bootstrap-button-with-react-router-57d2f6197588
//https://stackoverflow.com/questions/42463263/wrapping-a-react-router-link-in-an-html-button#answer-46088718
function ContinueButton(props) {
  let history = useHistory();
  let buttonText = (typeof props.name !== 'undefined') ? props.name : 'Continue';
  let disabled = (typeof props.disabled !== 'undefined') ? props.disabled : false;
  const curURL = new URL(window.location.href);

  return(
    <Button disabled={disabled} color="primary" className="float-end" aria-label="Save and continue"
      onClick={() => {
        if( props.onContinue)
          props.onContinue();
        else
          history.push({
            pathname: props.nextRoute,
            search: curURL.search
          });
      }}
    >
      {buttonText}
    </Button>
  );
}

//Presentational component to display the Back and Continue buttons.
//The Continue button has 2 ways to go to the next step:
//  1. With a callback to determine the next step (onContinue), which is the typical way, or 
//  2. If no callback available, it uses a string for the nextRoute ("/gather-info/main"). 
function PageControls(props) {
  return(
    <div className="container-fluid aa-page-controls border-top" role="navigation">
      <BackButton name={props.backName}/>
      <ContinueButton name={props.continueName} onContinue={props.onContinue} 
        disabled={props.continueDisabled}
        nextRoute={props.nextRoute} 
      />
    </div>
  );
}

export default PageControls;

